
//
const siteHeader = document.querySelector('.site-header');
const siteHeaderNavigation = siteHeader.querySelector('nav');
const siteHeaderMenuContainer = siteHeaderNavigation.querySelector('.navigation-drawer-container');

//
if (siteHeader !== null && siteHeaderNavigation !== null) {

    //------------------------------------------------------------------------------

    //add either "scroll-end" or "scroll-start" to the body element based on the direction of the user's scrolling (this will be used to apply scroll based reveals to the header and sidebar)
    let lastScroll = 0;
    let lastScrollOffset = 0;

    //
    window.addEventListener('scroll', () => {

        //
        if (window.scrollY <= 0) {
            document.body.classList.remove('scroll-start');
            return;
        }

        //
        if (window.scrollY > lastScroll && !document.body.classList.contains('scroll-end')) {
            document.body.classList.remove('scroll-start');
            document.body.classList.add('scroll-end');
        } else if (window.scrollY < lastScroll && document.body.classList.contains('scroll-end')) {
            document.body.classList.remove('scroll-end');
            document.body.classList.add('scroll-start');
        }

        //
        if (document.body.classList.contains('scroll-start')) {
            lastScrollOffset = window.scrollY;
        }

        //
        document.body.style.setProperty('--scroll-offset', `${((window.scrollY - lastScrollOffset) * -1)}px`);

        //
        lastScroll = window.scrollY;

    });

    //
    window.addEventListener('resize', () => {
        document.body.style.setProperty('--header-offset', `${siteHeader.getBoundingClientRect().height}px`);
    });

    //
    document.body.style.setProperty('--header-offset', `${siteHeader.getBoundingClientRect().height}px`);

    //------------------------------------------------------------------------------

    //add an interaction to the menu-button to open the "small viewport" menu
    siteHeader.querySelector('[data-action="open-navigation"]')?.addEventListener('click', () => {

        //
        siteHeaderNavigation.querySelectorAll('[data-open]').forEach((item) => {
            item.removeAttribute('data-open');
        });

        //
        siteHeader.toggleAttribute('data-menu-open');

    });

    //
    siteHeaderNavigation.querySelectorAll('.navigation-item[data-target]').forEach((item) => {
        item.addEventListener('click', (event) => {
            if (siteHeader.hasAttribute('data-menu-open')) {
                item.toggleAttribute('data-open');
                siteHeaderNavigation.querySelector(`.navigation-drawer[data-name="${item.dataset.target}"]`).toggleAttribute('data-open');
            }
        });
    });

    //------------------------------------------------------------------------------

    //how long does the user need to linger over a menu item to trigger it to open
    const MENU_OPEN_DELAY = 200;

    //track the timer for opening the main menu
    let openMenuTimer = null;

    //
    let isMenuOpen = false;
    let isOpenMenuSticky = false;

    //
    let currentAction = null;
    let nextAction = null;

    //
    function queueAction(action) {
        if (currentAction == null) {
            currentAction = action;
            processQueue();
        } else {
            nextAction = action;
        }
    }

    //
    function processQueue() {

        //
        if (currentAction.action == 'open') {

            //
            const menuToOpen = siteHeaderNavigation.querySelector(`.navigation-drawer[data-name="${currentAction.menu}"]`);

            //
            siteHeaderNavigation.classList.remove('closing');

            //
            siteHeaderNavigation.classList.toggle('opening', !isMenuOpen);
            siteHeaderNavigation.classList.toggle('open', isMenuOpen);

            //
            siteHeaderMenuContainer.style.height = `${menuToOpen.getBoundingClientRect().height}px`;

            //
            siteHeaderNavigation.querySelectorAll('.navigation-drawer.fadein').forEach((element) => {
                element.classList.remove('fadein');
            });

            //
            menuToOpen.classList.add('fadein');

            //
            isMenuOpen = true;

        }

        //
        if (currentAction.action == 'close') {

            //
            siteHeaderNavigation.classList.remove('opening');
            siteHeaderNavigation.classList.remove('open');

            //
            siteHeaderNavigation.classList.add('closing');

            //
            siteHeaderNavigation.querySelectorAll('.navigation-drawer.fadein').forEach((element) => {
                element.classList.remove('fadein');
            });

            //
            siteHeaderMenuContainer.style.height = `0rem`;

            //
            isMenuOpen = false;

            //
            isOpenMenuSticky = false;

        }

        //
        window.setTimeout(() => {

            //
            currentAction = nextAction;
            nextAction == null;

            //
            if (currentAction !== null) {
                processQueue();
            }

        }, ((window.matchMedia(`(prefers-reduced-motion: reduce)`) === true || window.matchMedia(`(prefers-reduced-motion: reduce)`).matches === true) ? 0 : 500));

    }

    //------------------------------------------------------------------------------

    //open the search menu
    siteHeader.querySelector('[data-action="open-search"]')?.addEventListener('click', () => {
        if (!siteHeader.hasAttribute('data-menu-open')) {

            //if the search menu is alredy open - treat the as a toggle
            if (siteHeaderMenuContainer.querySelector('.navigation-drawer[data-name="search"]').classList.contains('fadein')) {
                queueAction({ 'action' : 'close' });
                return;
            }

            //
            queueAction({'action' : 'open', 'menu' : 'search' });
            isOpenMenuSticky = true;

        }
    });

    //close the search menu
    siteHeader.querySelector('[data-action="close-search"]')?.addEventListener('click', () => {
        if (!siteHeader.hasAttribute('data-menu-open')) {
            queueAction({ 'action' : 'close' });
        }
    });

    //------------------------------------------------------------------------------

    //add mouse events to open the menu
    siteHeaderNavigation.querySelectorAll('.navigation-item[data-target]').forEach((item) => {

        //
        item.addEventListener('mouseenter', (event) => {


            if (siteHeader.hasAttribute('data-menu-open')) {
                return;
            }

            //
            if (isOpenMenuSticky == true) {
                return;
            }

            //if the menu is already open - do not delay - just go for it (as the queue will handle any mess)
            if (isMenuOpen) {
                queueAction({'action' : 'open', 'menu' : event.target.dataset.target });
                return;
            }

            //
            openMenuTimer = window.setTimeout(() => {
                queueAction({'action' : 'open', 'menu' : event.target.dataset.target });
            }, MENU_OPEN_DELAY);

        });

        //
        item.addEventListener('mouseleave', (event) => {
            window.clearTimeout(openMenuTimer)
        });

    });

    //
    document.querySelector('body').addEventListener('mouseover', (event) => {

        //
        if (isMenuOpen == false || isOpenMenuSticky == true) {
            return;
        }

        //
        let eventTarget = event.target;

        //move up the dom tree to check if the target or any of its parents match the selector (replicating the way jquery .on() works)
        while (eventTarget) {
            if (eventTarget.matches('.site-header nav')) {
                event.stopPropagation();
                return;
            }
            eventTarget = eventTarget?.parentElement;
        }

        //
        queueAction({ 'action' : 'close' });

    });

    //------------------------------------------------------------------------------

}